import { observer } from 'mobx-react'
import React from 'react'
import { ReactComponent as Close } from '../../svg/close.svg'


@observer
class ToastAlert extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      display: false,
      transitioning: false
    }
  }

  componentDidMount(){
    this.setState({
      dislay: false,
      transitioning: false
    })
  }

  transition(){
    this.setState({
      transitioning: true
    })
    setTimeout(() => {
      this.setState({
        transitioning: false
      })
    }, 2000)
  }

  componentDidUpdate(prevProps){
    if(prevProps.message !== this.props.message){
      this.setState({
        display: true,
      })
      this.transition()
      setTimeout(() => {
        this.setState({
          display: false
        })
        this.transition()
      }, 7500)
    }
  }

  close(){
    this.setState({
      display: false
    })
    this.transition()
  }

  render(){
    const { isError, message } = this.props
    const { display, transitioning } = this.state
    let className = display && !transitioning ? 'toast display' : 'toast'
    let style = {}
    if(!display && transitioning){
      className = 'toast transitioning'
      style = {
        opacity: 0
      }
    }
    if(display && transitioning){
      className = 'toast transitioning'
      style = {
        opacity: 1
      }
    }
    if(!display && !transitioning){
      className = 'toast hidden'
    }
    if(isError){
      className += ' error'
    }else{
      className += ' success'
    }
    //const className = isError ? 'toast error' : 'toast success'
    return (
      <div className={className} style={style}>
        <span className='toast__text'>
          {
            message ? message : isError ? 'Something went wrong' : 'Done'
          }
        </span>
        <Close 
          onClick={() => this.close()}
          style={{
            stroke: '#fff'
          }}
        />
      </div>
    )
  }

}

export default ToastAlert